import { allCountries as allCountyRegions, CountrySlug } from 'country-region-data';
import { FC, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FormTextField, FormSearchableSelect } from '../../../../lib/components';
import { CompanyForm, CompanyFormProps } from '../shared/companyForm';
import { countryAlpha2, countryOptions } from '../../../../misc/countries';

type Props = Omit<CompanyFormProps, 'children'>;

export const GeneralDataForm: FC<Props> = (props) => {
  const { t, i18n } = useTranslation();

  const language = i18n.resolvedLanguage;
  const countryNames = useMemo(() => countryOptions(language), [language]);

  const [country, setCountry] = useState<CountrySlug | undefined>(
    () => countryAlpha2(props.initialValues?.address?.country) as CountrySlug | undefined
  );

  const provinceNames = useMemo(() => {
    if (!country) return [];
    const match = allCountyRegions.find((c) => c[1] === country);
    if (!match) return [];
    return match[2].map((p) => ({
      text: p[0],
      value: p[0]
    }));
  }, [country]);

  return (
    <CompanyForm {...props}>
      <FormTextField
        label={t('company:STREET')}
        placeholder={t('company:STREET')}
        name="address.street_name"
        xs={6}
      />
      <FormTextField
        label={t('company:STREET_NUMBER')}
        placeholder={t('company:STREET_NUMBER')}
        name="address.street_number"
        xs={6}
      />
      <FormTextField
        label={t('company:ADDITION_TO_ADDRESS')}
        placeholder={t('company:ADDITION_TO_ADDRESS')}
        name="address.address_supplement"
        xs={12}
      />
      <FormTextField
        label={t('company:ZIP_CODE')}
        placeholder={t('company:ZIP_CODE')}
        name="address.zip_code"
        xs={6}
      />
      <FormTextField
        label={t('company:CITY')}
        placeholder={t('company:CITY')}
        name="address.city"
        xs={6}
      />
      <FormSearchableSelect
        label={t('company:PROVINCE')}
        placeholder={t('company:PROVINCE')}
        name="address.province"
        options={provinceNames}
        xs={6}
      />
      <FormSearchableSelect
        label={t('company:COUNTRY')}
        placeholder={t('company:COUNTRY')}
        name="address.country"
        options={countryNames}
        additionalOnChange={(value) => setCountry(value as CountrySlug)}
        xs={6}
      />
    </CompanyForm>
  );
};
